module.exports = __webpack_public_path__ + "static/media/lombo-de-pintado.5dac3e6e.jpg";